import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as themeConfig from './theme/theme.config.js';

try {
  const stored = localStorage.getItem(themeConfig.STORAGE_KEY) || 'system';
  themeConfig.applyCssTheme(stored);
} catch {
  themeConfig.applyCssTheme('light');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
